import request from '@/utils/request';

const loginApi = {
    // 注册
    register(phone,authCode,password,parentUserPhone){
        return request({
            url: '/app/login/auth/code',
            method: 'post',
            data: {
                // 'brandId':brandId,
                'phone':phone, // 手机号
                'authCode':authCode, // 验证码
                'password':password, // 密码
                'parentUserPhone':parentUserPhone, // 推荐人邀请码，不传则上级为品牌管理员
            },
        })
    },
    // 天御图形验证码验证
    checkTYCaptcha({account,ticket,randstr}){
        return request({
            url: '/app/check/ty/captcha',
            method: 'post',
            data: {
                'account': account, // 用户手机号
                'ticket': ticket, // 天御图形验证码
                'randstr': randstr, // 随机字符串
            }
        });
    },
    // 获取验证码
    getCode(receiveAccount){
        return request({
            url: '/app/send/auth/code',
            method: 'post',
            data: {
                'receiveAccount':receiveAccount, // 用户手机号
                // 'account': receiveAccount, // 验证手机号
            }
        })
    },
    // 获取APP下载地址
    getAppDownload(isGroup){
        return request({
            url: '/app/query/brand/config',
            method: 'post',
            data: {
                'isGroup':isGroup, // 是否对字段分组,1:是
            }
        })
    },
    // 判断手机号是否已经注册
    userIsExist(account){
        return request({
            url: '/app/query/user/is/exist',
            method: 'post',
            data: {
                'account':account, // 手机号
            }
        })
    },
    // 手机号(用户ID)密码登录
    login(userId,phone,password){
        return request({
            url: '/app/login/password',
            method: 'post',
            data: {
                'userId':userId, // 用户ID
                'password':password,// 密码
                'account':phone, // 手机号
            }
        })
    },
    // 手机号验证码登录
    loginCode(phone,authCode,password){
        return request({
            url: '/app/login/auth/code',
            method: 'post',
            data: {
                'phone':phone,
                'authCode':authCode,
                'password':password,
            }
        })
    },
    // 设置用户密码
    setPassword(account,authCode,password,passwordType){
        return request({
            url: '/app/set/password',
            method: 'post',
            data: {
                'account':account, // 用户手机号
                'authCode':authCode, // 验证码
                'password':password, // 设置的密码
                'passwordType':passwordType, // 这只密码的类型，1：登录密码，3：交易密码
            }
        })
    },
}

export default loginApi;